const {
  ModalTest: {
    actions: { toggleModal },
  },
} = window.Edocat.Components;

const { GridOn } = window.MaterialIcons;
const { Link, withStyles } = window.Material;

import { Header } from '../../types/types';
import { Dispatch } from 'redux';
import TableModal from './TableModal';
import { fetchObjectsToCache } from '../../../../actions/objectCache';
import { extractNoderefsFromFormTableFieldDataJSON } from '../../../../utils/tableAsyncCells';

const styles = {
  link: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
  icon: {
    marginRight: '5px',
  },
};

interface TableProps {
  actions: any;
  modal: any;
  classes: any;
  header: Header;
  body: { [key: string]: string }[];
  name: string;
  index: number;
}

class TableButton extends (window as any)?.React.PureComponent<TableProps> {

  handleButtonCLick = () => {
    const { actions, modal, header, body, classes, name } = this.props;
    const index = this.props?.index ? this.props.index : 0;
    actions.fetchObjectsToCache(extractNoderefsFromFormTableFieldDataJSON(body))
      .then(() => actions.toggleModal(true, `${name}TableModal${index}`));
  }

  render() {
    const { actions, modal, header, body, classes, name } = this.props;
    const index = this.props?.index ? this.props.index : 0;
    return (
      <div>
        <Link onClick={() => this.handleButtonCLick()} classes={{ root: classes.link }}>
          <GridOn fontSize="small" classes={{ root: classes.icon }} />
          {window.Alfresco.messages.global['edocat.forms.show-table']}
        </Link>
        {modal?.[`${name}TableModal${index}`]?.isOpen && (
          <TableModal index={index} header={header} body={body} name={name} />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return ({
    modal: state?.modal,
    usedObjects: state?.cacheReducer?.usedObjects || {},
  })
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  actions: window.redux.bindActionCreators({ toggleModal, fetchObjectsToCache }, dispatch),
});

export default window.reactRedux.connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(TableButton));
